import React from "react";
import PropTypes from "prop-types";
import { Redirect, Switch, Route, useLocation } from "react-router-dom";

import PromoDisplay from "../views/Promo/PromoDisplay";
import PromoGroupsDisplay from "../views/Promo/PromoGroupsDisplay";
import PromoGroupDetail from "../views/Promo/PromoGroupDetail";
import PromoGroupWrite from "../views/Promo/PromoGroupWrite";
import PromoWrite from "../views/Promo/PromoWrite";
import PermissionedRoute from "./PermissionedRoute";
import Permissions from "../permissions";

export const PromosContentRouter = ({ handleShowTabs, handleChangeTab }) => {
  const location = useLocation();
  // cannot reuse `background` if you are nested inside another router that also has `background` in namespace
  const nestedBackground = location?.state?.nestedBackground || location;

  return (
    <>
      <Switch location={nestedBackground || location}>
        <PermissionedRoute permission={Permissions.readPromos} exact path="/promos/:promoType">
          <PromoDisplay handleChangeTab={handleChangeTab} />
        </PermissionedRoute>
        <PermissionedRoute permission={Permissions.readPromos} exact path="/promo-groups">
          <PromoGroupsDisplay handleShowTabs={handleShowTabs} />
        </PermissionedRoute>
        <PermissionedRoute
          permission={Permissions.readPromos}
          exact
          path="/promo-groups/:promoGroupId"
        >
          <PromoGroupDetail handleShowTabs={handleShowTabs} />
        </PermissionedRoute>
        <Route path="/promos">
          <Redirect to="/promos/discount" />
        </Route>
      </Switch>
      {/* modals */}
      {nestedBackground && (
        <Switch>
          <PermissionedRoute
            permission={[Permissions.readPromos, Permissions.writePromos]}
            path="/promos/:promoType/:promoId/edit"
          >
            <PromoWrite />
          </PermissionedRoute>
          <PermissionedRoute
            permission={[Permissions.readPromos, Permissions.writePromos]}
            path="/promo-groups/:promoGroupId/edit"
          >
            <PromoGroupWrite />
          </PermissionedRoute>
        </Switch>
      )}
    </>
  );
};

PromosContentRouter.propTypes = {
  handleChangeTab: PropTypes.func.isRequired,
  handleShowTabs: PropTypes.func.isRequired,
};

export default PromosContentRouter;
